const withSNR = (store, defaultModuleName) => {
  const appParam = store.getState().getIn(['modules', 'axp-card-member-apply-root', 'query', 'appParam']);
  const appData = store.getState().getIn(['modules', 'axp-retrieve-application', 'appData']);

  // Checks if appParam query exist in url and if successful
  // login hasn't happened on SNR application yet
  // appaparam is there and appData is there
  if (appParam && (!appData || (appData.isEmpty && appData.isEmpty()))) {
    return 'axp-retrieve-application';
  }
  return defaultModuleName;
};

export default withSNR;
